import types from '../mutation-types';
import AiAgentAPI from '../../api/aiAgents';

export const state = {
  records: [],
  vectorStoreFiles: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingVectorStoreFiles: false,
    isDeletingVectorStoreFile: false,
  },
};

export const getters = {
  getVectorStoreFiles(_state) {
    return _state.vectorStoreFiles;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

// SET_TYPEBOT_UI_FLAG mantém o nome: é a ui-flag GENÉRICA deste módulo (todas
// as ações do Atendente de IA a usam), não resíduo da integração legada.
export const actions = {
  upsertAIAgent: async function upsertAIAgent({ commit }, agentBotData) {
    commit(types.SET_TYPEBOT_UI_FLAG, { isCreating: true });
    try {
      const response = await AiAgentAPI.upsertAIAgent(agentBotData);
      // Nós não adicionamos à store local, pois ele será gerenciado
      // como um agent_bot normal depois de criado.
      return response.data;
    } catch (error) {
      // Preservar informações completas do erro, incluindo status code
      const enhancedError = new Error(error?.response?.data?.error || error?.response?.data?.message || error?.message);
      enhancedError.status = error?.response?.status;
      enhancedError.response = error?.response;
      throw enhancedError;
    } finally {
      commit(types.SET_TYPEBOT_UI_FLAG, { isCreating: false });
    }
  },

  uploadKnowledgeBaseFiles: async function uploadKnowledgeBaseFiles(
    { commit },
    { agentBotId, files }
  ) {
    commit(types.SET_TYPEBOT_UI_FLAG, { isUpdating: true });
    try {
      await AiAgentAPI.uploadKnowledgeBaseFiles(agentBotId, files);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_TYPEBOT_UI_FLAG, { isUpdating: false });
    }
  },

  getVectorStoreFiles: async function getVectorStoreFiles(
    { commit },
    { agentBotId, params }
  ) {
    commit(types.SET_TYPEBOT_UI_FLAG, { isFetchingVectorStoreFiles: true });
    try {
      const response = await AiAgentAPI.getVectorStoreFiles(agentBotId, params);
      commit(types.SET_VECTOR_STORE_FILES, response.data.vector_store_files);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_TYPEBOT_UI_FLAG, {
        isFetchingVectorStoreFiles: false,
      });
    }
  },

  deleteKnowledgeBaseFile: async function deleteKnowledgeBaseFile(
    { commit },
    { agentBotId, fileId }
  ) {
    commit(types.SET_TYPEBOT_UI_FLAG, { isDeletingVectorStoreFile: true });
    try {
      await AiAgentAPI.deleteKnowledgeBaseFile(agentBotId, fileId);
      commit(types.REMOVE_VECTOR_STORE_FILE, fileId);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_TYPEBOT_UI_FLAG, { isDeletingVectorStoreFile: false });
    }
  },

  downloadFile: async function downloadFile(
    { commit },
    { agentBotId, fileId }
  ) {
    commit(types.SET_TYPEBOT_UI_FLAG, { isFetching: true });
    try {
      const response = await AiAgentAPI.downloadFile(agentBotId, fileId);
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_TYPEBOT_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_TYPEBOT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_VECTOR_STORE_FILES](_state, files) {
    _state.vectorStoreFiles = files;
  },

  [types.REMOVE_VECTOR_STORE_FILE](_state, fileId) {
    _state.vectorStoreFiles = _state.vectorStoreFiles.filter(
      file => file.id !== fileId
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 